/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Withdrawal_TitleInputs */

const en_consumer_declaration_withdrawal_title = /** @type {(inputs: Consumer_Declaration_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Withdraw from a subscription`)
};

const de_consumer_declaration_withdrawal_title = /** @type {(inputs: Consumer_Declaration_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement widerrufen`)
};

const fr_consumer_declaration_withdrawal_title = /** @type {(inputs: Consumer_Declaration_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se rétracter d’un abonnement`)
};

const es_consumer_declaration_withdrawal_title = /** @type {(inputs: Consumer_Declaration_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desistir de una suscripción`)
};

const it_consumer_declaration_withdrawal_title = /** @type {(inputs: Consumer_Declaration_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recedi da un abbonamento`)
};

const nl_consumer_declaration_withdrawal_title = /** @type {(inputs: Consumer_Declaration_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement herroepen`)
};

const pl_consumer_declaration_withdrawal_title = /** @type {(inputs: Consumer_Declaration_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odstąp od subskrypcji`)
};

const fi_consumer_declaration_withdrawal_title = /** @type {(inputs: Consumer_Declaration_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peruuta tilaus`)
};

const da_consumer_declaration_withdrawal_title = /** @type {(inputs: Consumer_Declaration_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortryd et abonnement`)
};

const sv_consumer_declaration_withdrawal_title = /** @type {(inputs: Consumer_Declaration_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frånträd en prenumeration`)
};

/**
* | output |
* | --- |
* | "Withdraw from a subscription" |
*
* @param {Consumer_Declaration_Withdrawal_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_withdrawal_title = /** @type {((inputs?: Consumer_Declaration_Withdrawal_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Withdrawal_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_withdrawal_title(inputs)
	if (locale === "fr") return fr_consumer_declaration_withdrawal_title(inputs)
	if (locale === "es") return es_consumer_declaration_withdrawal_title(inputs)
	if (locale === "it") return it_consumer_declaration_withdrawal_title(inputs)
	if (locale === "nl") return nl_consumer_declaration_withdrawal_title(inputs)
	if (locale === "pl") return pl_consumer_declaration_withdrawal_title(inputs)
	if (locale === "fi") return fi_consumer_declaration_withdrawal_title(inputs)
	if (locale === "da") return da_consumer_declaration_withdrawal_title(inputs)
	if (locale === "sv") return sv_consumer_declaration_withdrawal_title(inputs)
	return en_consumer_declaration_withdrawal_title(inputs)
});